import { isLoggedInType } from "./loggedin-types-util";

export const taggedPromoTile = (contentfulPromoTileOptions, isUserLoggedIn) => {
  return contentfulPromoTileOptions.find((promoTile) => {
    const tileTags = promoTile?.metadata?.tags || [];
    const tileHasTags = tileTags.length;
    if (!tileHasTags) {
      return;
    }
    const tileIsForLoggedInUsers = tileTags.some((tag) => isLoggedInType(tag));
    if (isUserLoggedIn === tileIsForLoggedInUsers) {
      return promoTile;
    }
  });
};
